<app-header-bar
  [dob]="testDob"
  [showClientDetails]="true"
  [showDate]="false"
  age="3y 4m"
  backDestination="/courses"
  title="Marie Claire"
/>
<br />
<app-primary-card class="main-card" title="REDDI Response Icons">
  <div class="service-group">
    <app-reddi-response-icon outcome="positive" size="10" type="detection" />
    <app-reddi-response-icon outcome="negative" size="20" type="detection" />
    <app-reddi-response-icon outcome="neutral" size="30" type="detection" />
  </div>
  <div class="service-group">
    <app-reddi-response-icon outcome="positive" size="30" type="imitation" />
    <app-reddi-response-icon outcome="negative" size="20" type="imitation" />
    <app-reddi-response-icon outcome="neutral" size="10" type="imitation" />
  </div>
</app-primary-card>
<app-primary-card class="main-card">
  <div class="service-group">
    <span class="mat-headline-2">My Clients</span>
    <app-tooltip
      class="tooltip"
      height="14"
      id="tooltip"
      left="28"
      top="-22"
      width="225"
    >
      You are the case manager for these clients.
    </app-tooltip>
  </div>
</app-primary-card>

<app-primary-card class="main-card" title="Logos">
  <div class="service-group">
    <app-reddi-logo />
  </div>
  <div class="service-group">
    <app-flip-logo />
  </div>
</app-primary-card>
<app-primary-card
  class="main-card"
  subtitle="Test the component services"
  title="Services"
>
  <div class="service-group">
    <h1>Client Service</h1>
    <div class="button-group">
      <button (click)="list('', '', '', 100)" color="primary" mat-raised-button>
        List
      </button>
      <button (click)="org()" color="primary" mat-raised-button>Org</button>
      <button (click)="details()" color="primary" mat-raised-button>
        Details
      </button>
      <button (click)="toolsummaries()" color="primary" mat-raised-button>
        Tool Summaries
      </button>
      <button (click)="create()" color="primary" mat-raised-button>
        Create
      </button>
      <button (click)="update()" color="primary" mat-raised-button>
        Update
      </button>
    </div>
  </div>
  <div class="service-group">
    <h1>Lookup Service</h1>
    <div class="button-group">
      <button (click)="LookupGetGenders()" color="primary" mat-raised-button>
        Genders
      </button>
      <button color="primary" mat-raised-button>Case Managers</button>
      <button color="primary" mat-raised-button>Locations</button>
    </div>
  </div>
  <div class="service-group">
    <h1>FLIP Service</h1>
    <div class="button-group">
      <button color="primary" mat-raised-button>History</button>
      <button color="primary" mat-raised-button>Get Assessment</button>
      <button color="primary" mat-raised-button>Submit</button>
    </div>
  </div>
  <div class="service-group">
    <h1>REDDI Service</h1>
    <div class="button-group">
      <button color="primary" mat-raised-button>Configuration</button>
      <button color="primary" mat-raised-button>Get Assessment</button>
      <button color="primary" mat-raised-button>Submit</button>
      <button (click)="getIteration()" color="primary" mat-raised-button>
        Get Iteration
      </button>
    </div>
  </div>
  <div class="service-group">
    <h1>Review Service</h1>
    <div class="button-group">
      <button color="primary" mat-raised-button>Get Reviews</button>
      <button color="primary" mat-raised-button>Mark Reviewed</button>
      <button color="primary" mat-raised-button>List</button>
      <button color="primary" mat-raised-button>Reviewed</button>
      <button color="primary" mat-raised-button>Un-reviewed</button>
    </div>
  </div>
  <div class="service-group">
    <h1>Subscription Service</h1>
    <div class="button-group">
      <button color="primary" mat-raised-button>Courses</button>
      <button color="primary" mat-raised-button>Ongoing</button>
      <button color="primary" mat-raised-button>Finalised</button>
      <button color="primary" mat-raised-button>Has Tools</button>
    </div>
  </div>
  <div class="service-group">
    <h1>Features Service</h1>
    <div class="button-group">
      <button (click)="getFeatures()" color="primary" mat-raised-button>
        GetFeatures
      </button>
    </div>
  </div>
</app-primary-card>
<app-primary-card
  class="main-card"
  subtitle="Testing the Logger service"
  title="Logger"
>
  <button (click)="testLog()">Log Test</button>
</app-primary-card>
<app-primary-card
  class="main-card"
  subtitle="Ensure the material typography is working"
  title="Material Typography"
>
  <h1>The quick brown fox jumps over the lazy dog.</h1>
  <div class="mat-h1">The quick brown fox jumps over the lazy dog.</div>
  <p>H2</p>
  <h2>The quick brown fox jumps over the lazy dog.</h2>
  <div class="mat-h2">The quick brown fox jumps over the lazy dog.</div>
  <p>H3</p>
  <h3>The quick brown fox jumps over the lazy dog.</h3>
  <div class="mat-h3">The quick brown fox jumps over the lazy dog.</div>
  <p>H4</p>
  <h4>The quick brown fox jumps over the lazy dog.</h4>
  <div class="mat-h4">The quick brown fox jumps over the lazy dog.</div>
  <p>H5</p>
  <h5>The quick brown fox jumps over the lazy dog.</h5>
  <div class="mat-h5">The quick brown fox jumps over the lazy dog.</div>
  <p>H6</p>
  <h6>The quick brown fox jumps over the lazy dog.</h6>
  <div class="mat-h6">The quick brown fox jumps over the lazy dog.</div>
  <p>Body</p>
  <div class="mat-body">The quick brown fox jumps over the lazy dog.</div>
  <div class="mat-body-strong">
    The quick brown fox jumps over the lazy dog.
  </div>
  <div class="light-button">The quick brown fox jumps over the lazy dog.</div>
</app-primary-card>

<app-primary-card
  class="main-card"
  subtitle="Ensure the Table is working - Standard"
  title="Material Table - Standard"
>
  <app-table
    (onLinkButtonClick)="onTableLinkButtonClick($event)"
    (onLinkClick)="onTableLinkClick($event)"
    (onQuickViewButtonClick)="onQuickViewButtonClick($event)"
    [columnDefinitions]="_table1ColumnDefinitions"
    [columnsToDisplay]="_table1ColumnsToDisplay"
    [dataSource]="data"
    [kind]="'standard'"
    [pageSize]="12"
    [showPager]="true"
  >
  </app-table>
</app-primary-card>

<app-primary-card
  class="main-card"
  subtitle="Ensure the Table is working - Background Colour Vairant"
  title="Material Table - With Background Color"
>
  <app-table
    (onLinkButtonClick)="onTableLinkButtonClick($event)"
    (onLinkClick)="onTableLinkClick($event)"
    (onQuickViewButtonClick)="onQuickViewButtonClick($event)"
    [columnDefinitions]="_table2ColumnDefinitions"
    [columnsToDisplay]="_table2ColumnsToDisplay"
    [dataSource]="_table2Data"
    [kind]="'standard'"
    [pageSize]="3"
    [showPager]="true"
  >
  </app-table>
</app-primary-card>

<app-primary-card
  class="main-card"
  size="large"
  subtitle="Ensure the Table is working - Styled header"
  title="Material Table - Styled header"
>
  <app-table
    (onLinkButtonClick)="onTableLinkButtonClick($event)"
    (onLinkClick)="onTableLinkClick($event)"
    (onQuickViewButtonClick)="onQuickViewButtonClick($event)"
    [columnDefinitions]="_table3ColumnDefinitions"
    [columnsToDisplay]="_table3ColumnsToDisplay"
    [dataSource]="_table3Data"
    [kind]="'styled-header'"
    [pageSize]="8"
    [showPager]="true"
  >
  </app-table>
</app-primary-card>

<app-primary-card
  class="main-card"
  subtitle="Ensure the Table is working - Standard - No Pager"
  title="Material Table - Standard - No Pager"
>
  <app-table
    (onLinkButtonClick)="onTableLinkButtonClick($event)"
    (onLinkClick)="onTableLinkClick($event)"
    (onQuickViewButtonClick)="onQuickViewButtonClick($event)"
    [columnDefinitions]="_table4ColumnDefinitions"
    [columnsToDisplay]="_table4ColumnsToDisplay"
    [dataSource]="_table4Data"
    [kind]="'standard'"
    [pageSize]="4"
    [showPager]="false"
  >
  </app-table>
  <app-category-tile [color]="'warn'"> Action</app-category-tile>
  <br />
  <app-category-tile> Noting</app-category-tile>
  <br />
  <app-category-tile> Celabration</app-category-tile>
</app-primary-card>

<app-primary-card
  class="main-card"
  subtitle="Quick View Button"
  title="Quick View"
>
  <app-quick-view-button
    [data]="'QuickViewdata'"
    [fieldName]="'FieldName'"
    color="primary"
    >Quick View
  </app-quick-view-button>

  <app-quick-view-button
    [data]="'QuickViewdata'"
    [fieldName]="'FieldName'"
    color="accent"
    >Quick View
  </app-quick-view-button>
</app-primary-card>
<app-primary-card class="main-card" title="Help Tip">
  <app-help-tip [title]="_helpTipTitle" [value]="_helpTipValue"></app-help-tip>
</app-primary-card>
<app-primary-card
  class="main-card"
  subtitle="All variants of Reddi response buttons"
  title="Reddi Response Buttons"
>
  <div *ngFor="let row of _reddiRoundDemo" class="service-group">
    <div *ngFor="let button of row.rowButtons" class="spacer-line">
      <app-reddi-response-button
        (click)="myclick(button.id)"
        [kind]="button.kind"
        [type]="button.type"
        [value]="button.value"
      />
    </div>
    <div class="spacer-line">
      <app-link [color]="'primary'" [kind]="'standard'" showIcon="false"
        >Clear
      </app-link>
    </div>
    <app-incorrect-sound-tooltip
      [control]="row.incorrectSoundTooltips.control"
      [id]="row.incorrectSoundTooltips.id"
      [left]="310"
      [showTooltip]="row.incorrectSoundTooltips.showTooltip"
      [style.clear]="'left'"
      [top]="41"
    />
    <div style="clear: left"></div>
  </div>
  <div>
    Text Entry (1):
    {{ _reddiRoundDemo[0].incorrectSoundTooltips.control.value }}
  </div>
  <div>
    Text Entry (2):
    {{ _reddiRoundDemo[1].incorrectSoundTooltips.control.value }}
  </div>
</app-primary-card>
<app-primary-card
  class="main-card"
  subtitle="Checkboxes that behave like Radio buttons"
  title="Reddi Tabular Checkboxes"
>
  <div class="spacer">
    <app-reddi-tabular-checkbox [checkboxes]="_checkboxes" />
  </div>
</app-primary-card>

<app-primary-card class="main-card" subtitle="Link Variations" title="Links">
  <div>
    <app-link
      [showIcon]="false"
      color="primary"
      destination="'/courses'"
      kind="link"
      openInNewTab="false"
      >Marie Claire
    </app-link>
  </div>
  <div>
    <app-link
      [showIcon]="false"
      color="accent"
      destination="'/courses'"
      kind="link"
      openInNewTab="false"
      >Marie Claire
    </app-link>
  </div>
  <div>
    <app-link
      [showIcon]="false"
      color="warn"
      destination="'/courses'"
      kind="link"
      openInNewTab="false"
      >Marie Claire
    </app-link>
  </div>
  <div>
    <app-link
      [showIcon]="true"
      color="primary"
      destination="'/courses'"
      kind="icon"
      openInNewTab="false"
      >View Report
    </app-link>
  </div>
  <div>
    <app-link
      [showIcon]="true"
      color="accent"
      destination="'/courses'"
      kind="icon"
      openInNewTab="false"
      >View Report
    </app-link>
  </div>
  <div>
    <app-link
      [showIcon]="true"
      color="warn"
      destination="'/courses'"
      kind="icon"
      openInNewTab="false"
      >View Report
    </app-link>
  </div>
</app-primary-card>
<app-primary-card
  class="main-card"
  subtitle="Category Pill Variation"
  title="Category Pill"
>
  <div style="margin-bottom: 10px">
    <app-category-pill buttonType="Mostly">Mostly</app-category-pill>
  </div>
  <div style="margin-bottom: 10px">
    <span>
      <app-category-pill buttonType="Rarely">Rarely</app-category-pill>
    </span>
  </div>
  <div>
    <span>
      <app-category-pill buttonType="Blank"></app-category-pill>
    </span>
  </div>
</app-primary-card>
<app-primary-card
  class="main-card"
  subtitle="Variations of Flip button"
  title="Flip Button"
>
  <app-flip-button kind="accent" />
  <app-flip-button kind="primary" />
</app-primary-card>
<app-primary-card
  class="main-card"
  subtitle="Assessment side card used in FLI-P"
  title="Flip Assessment Side Card"
>
  <app-flip-assessment-side-card
    [flipAssessmentGroups]="_flipAssessmentGroup"
  />
</app-primary-card>
<app-primary-card
  class="main-card"
  subtitle="Combination of side card, edit control and action button"
  title="FLI-P Assessment Notes Side Card"
>
  <app-notes-side-card
    #notesSideCard
    [length]="maxLength"
    [textAreaControl]="_clientForm.controls['textArea']"
    class="notes-side-card"
    initialText="some text"
  />
  <br />
  <button (click)="onSubmit()" [disabled]="!_clientForm.valid">Submit</button>
</app-primary-card>
<div style="margin-bottom: 20px">
  <app-primary-card
    class="main-card"
    subtitle="Assessment side card used in FLI-P"
    title="Flip Item List"
  >
    <button (click)="scrollToItem('Item 1.6')">Scroll to Item</button>
    <div class="scroll-container">
      <div *ngFor="let item of flipItems" style="margin-bottom: 10px">
        <app-flip-item-summary
          id="flipItem{{ item.number }}"
          #flipItemContainerScroll
          #flipItem{{item.number}}
          (itemClicked)="handleItemClick(item.number)"
          [buttonType]="item.score"
          [description]="item.description"
          [number]="item.number"
          [score]="item.score"
          [variant]="'score-pill'"
        ></app-flip-item-summary>

        <app-flip-item-summary
          #flipItemContainer
          [description]="item.description"
          [number]="item.number"
          [score]="item.score"
          [variant]="'score-text'"
        ></app-flip-item-summary>
      </div>
    </div>
  </app-primary-card>
</div>

<div style="margin-bottom: 20px">
  <app-primary-card class="main-card" title="Collapsible Example">
    <div style="margin-bottom: 10px">
      <app-collapsible [items]="data_collapsible"></app-collapsible>
    </div>
  </app-primary-card>
</div>
<div class="main-card" style="margin-bottom: 20px">
  <div style="margin-bottom: 10px; margin-top: 10px">
    <app-flip-view-main-card
      [items]="data_collapsible"
      [lastAssessmentDetails]="'Assessment Date : 15 Dec, 2022'"
      [paddingSize]="'large'"
      [size]="'large'"
    ></app-flip-view-main-card>
  </div>
</div>
<div style="margin-bottom: 20px">
  <app-primary-card
    class="main-card"
    size="medium"
    title="Reddi distance radio button"
  >
    <div style="margin-top: 25px">
      <app-reddi-distance-radio-button
        (selectionChange)="onDistanceSelectionChange($event)"
      >
        <!-- radio buttons -->
      </app-reddi-distance-radio-button>
    </div>
  </app-primary-card>
  <app-primary-card height="617" class="reddi-instance-primary-card">
    <div><button (click)="loadData()">Load Data</button></div>
    <div class="reddi-instance-locked-container">
      <span class="material-symbols-outlined icon">lock</span>
      <span class="text">This assessment is locked</span>
    </div>
    <app-table
      id="reddi-round-table"
      [dataSource]="_tableData"
      [columnsToDisplay]="_tableColumnsToDisplay"
      [columnDefinitions]="_tableColumnDefinitions"
      [pageSize]="12"
      kind="standard"
      (onEditClick)="openEditModal($event.element, $event.index)"
    />
  </app-primary-card>
</div>
